module.exports = __webpack_public_path__ + "img/3283869.7f2d54f1.jpg";